export default "__VITE_ASSET__CEY8gpM1__"